// <pos-order-grid/> — POS 點餐主介面
// 左：菜單；右：購物車
// see architecture.md#L580

class PosOrderGrid extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: grid;
          grid-template-columns: 1fr 380px;
          gap: var(--s-5);
          height: calc(100vh - 64px);
          padding: var(--s-4);
          box-sizing: border-box;
        }
        @media (max-width: 768px) {
          :host { grid-template-columns: 1fr; }
        }
        .panel {
          background: var(--bg-elevated);
          border-radius: var(--r-lg);
          overflow-y: auto;
          padding: var(--s-4);
        }
      </style>
      <div class="panel">
        <pos-menu-grid></pos-menu-grid>
      </div>
      <div class="panel">
        <pos-cart></pos-cart>
      </div>
    `;
  }
}

customElements.define('pos-order-grid', PosOrderGrid);
